//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { ContentTypeGroup, Language, ContentType } from '@constants'

const EditorUserLevels = Object.freeze([3, 4, 8])
const FLOURISH_EMBED_SCRIPT_SRC = 'https://public.flourish.studio/resources/embed.js'
const FLOURISH_LOADER_SCRIPT_ID = 'telecompaper-flourish-embed-loader'
const FLOURISH_EMBED_BASE_URL = 'https://flo.uri.sh'
const FLOURISH_APP_BASE_URL = 'https://app.flourish.studio'
let flourishScriptLoadPromise = null
let flourishResizeListenerAdded = false

const CREATE_USER_SHARE = gql`
  mutation ($data: CreateUserShareInput) {
    createUserShare(data: $data) {
      id
    }
  }
`

export default {
  scrollToTop: true,
  data() {
    return {
      access: true,
      article: null,
      related: [],
      loadedImg: false,
      brokenImg: false,
      showPlaceholder: true,
      productPrice: null,
      needToRegister: false,
      needToSubscribe: false,
      showSingleLogin: false,
      waitingForPin: false,
      confirmationEmail: null,
      password: null,
      showLogin: false,
      showForgotPassword: false,
      isDownloading: false,
      ContentType,
      startDownload: false,
      externalId: null,
      isShowingCompleteAccount: false,
      isRefreshingAfterAuth: false,
      Language
    }
  },
  async fetch() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    this.$nuxt.$on('accesscontrol', (val) => {
      this.setBreadcrumb({
        isShow: false
      })
      this.$nuxt.$emit('topbanner', {
        isShow: false
      })
      switch (val) {
        case 'subscribe':
          this.needToSubscribe = true
          break
        case 'register':
          this.needToRegister = true
          break
        case 'singlelogin':
          this.showSingleLogin = true
          break
      }
    })

    this.$nuxt.$on('on-auth-change', async (isAuthenticated) => {
      if (isAuthenticated) {
        await this.refreshAfterAuthChange()
        return
      }

      await this.refresh(true)
    })

    this.$nuxt.$on('startDownload', () => {
      this.startDownload = true
    })

    this.externalId = this.queryId

    if (Number.isNaN(this.externalId)) {
      this.externalId = await this.getExternalIdFromSlug()
    }

    if (!this.externalId) {
      this.$router.push({
        path: `/?utm_source=-&utm_medium=-&utm_campaign=-&utm_content=ArticleNotAvailable`
      })
      return
    }

    await this.refresh(true)
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  head() {
    if (!this.article) {
      return { title: 'Telecompaper', meta: [] }
    }

    const title = `${this.article.title} - Telecompaper`
    const description = this.article.shortAbstract || this.article.abstract?.substring(0, 512) || ''
    const locale = this.article.language?.locale || 'en'

    let image = ''
    if (this.article.imageUrl) {
      try {
        image = this.$img.getImage(this.article.imageUrl).url
      } catch (error) {
        console.warn('Failed to process article image:', error)
      }
    }

    return {
      title,
      meta: [
        { httpEquiv: 'content-language', content: locale },
        { hid: 'description', name: 'description', content: description },

        // Open Graph tags
        { hid: 'og:type', property: 'og:type', content: 'article' },
        { hid: 'og:site_name', property: 'og:site_name', content: 'Telecompaper' },
        { hid: 'og:title', property: 'og:title', content: this.article.title },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'og:url', property: 'og:url', content: this.canonical },
        image && { hid: 'og:image', property: 'og:image', content: image },

        // Twitter Card tags
        { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:title', name: 'twitter:title', content: this.article.title },
        { hid: 'twitter:description', name: 'twitter:description', content: description },
        image && { hid: 'twitter:image', name: 'twitter:image', content: image }
      ].filter(Boolean),
      link: [{ rel: 'canonical', href: this.canonical }]
    }
  },
  fetchOnServer: true,
  jsonld() {
    let jsonld = {}
    const dateModified = {}
    const author = {}
    if (this.article) {
      if (this.updates && this.updates.length > 0) {
        dateModified.dateModified = this.$dayjs(this.updates[0].changedAt).format()
      }
      if (this.article && this.articleAuthors && this.articleAuthors.length > 0) {
        author.author = this.article.articleAuthors.map((author) => {
          return {
            '@type': 'Person',
            name: `${author.user.firstName} ${author.user.lastName}`,
            url: ''
          }
        })
      }
      jsonld = {
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://google.com/article'
        },
        headline: this.article.title,
        image: [this.$img.getImage(this.article.imageUrl)],
        datePublished: this.$dayjs(this.article.date).format(),
        ...dateModified,
        ...author,
        publisher: {
          '@type': 'Organization',
          name: 'Telecompaper',
          logo: {
            '@type': 'ImageObject',
            url: `${this.$config.baseURL}/_nuxt/assets/img/svgs/logo.svg`
          }
        },
        isAccessibleForFree: 'False',
        hasPart: {
          '@type': 'WebPageElement',
          isAccessibleForFree: 'False',
          cssSelector: '.paywall'
        }
      }
    }
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      ...jsonld
    }
  },
  computed: {
    filters: sync('filters'),
    cartItems: sync('cart/items'),
    slugParts() {
      const slug = this.$route.path.split('/').filter(Boolean)[1]?.split('--')
      return slug
    },
    pathContentType() {
      return this.$route.path.split('/').filter(Boolean)[0]
    },
    isPartnerContent() {
      if (this.article && this.article.contentType && this.article.contentType.contentTypeGroup)
        return this.article.contentType.contentTypeGroup.id === ContentTypeGroup.PARTNER_CONTENT
      return false
    },
    queryId() {
      return Number.parseInt(this.slugParts[this.slugParts.length - 1])
    },
    titleSlug() {
      return this.slugParts?.[0]
    },
    contentTypeSlug() {
      return this.$route.path.split('/').filter(Boolean)[0]
    },
    content() {
      if (!this.article) return null
      return this.article.content || this.article.abstract
    },
    location() {
      const location = this.article.country != null ? this.article.country : this.article.region
      return location
    },
    updates() {
      return this.article.articleUpdates || []
    },
    hasUpdate() {
      return this.updates.length > 0
    },
    latestUpdate() {
      return !this.hasUpdate ? null : this.updates[0].changedAt
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    isOld() {
      if (!this.article) return false
      return this.$dayjs(this.article.date).add(1, 'year') < new Date()
    },
    account() {
      return this.$store.get('user/user') || null
    },
    editorUserLevels() {
      if (!this.account || !this.account.userLevels) return []
      return this.account.userLevels.filter((x) => EditorUserLevels.includes(x.levelId))
    },
    canonical() {
      return (
        this.$config.baseURL +
        (this.article
          ? `/${this.getContentTypeUrlName(this.article.contentType)}/${this.article.slug}--${this.article.externalId}`
          : `/${this.pathContentType}/${this.titleSlug}--${this.externalId}`)
      )
    }
  },
  watch: {
    languageId() {
      if (this.showPlaceholder === true || !this.article || this.languageId === this.article?.languageId) return
      this.$router.replace({ path: '/' })
    },
    account(newAccount, oldAccount) {
      if (newAccount && !oldAccount && this.needToRegister) {
        this.refreshAfterAuthChange()
      }
    },
    content() {
      this.scheduleFlourishEmbeds()
    },
    'article.contentAfter'() {
      this.scheduleFlourishEmbeds()
    }
  },
  beforeDestroy() {
    this.removeFlourishEmbeds()
    this.$nuxt.$off('on-auth-change')
    this.$nuxt.$off('accesscontrol')
    this.$nuxt.$off('startDownload')
    this.$nuxt.$emit('topbanner', {
      isShow: true
    })
  },
  beforeMount() {
    this.setFilters({})
  },
  mounted() {
    this.showLogin = false
    if (this.account && this.needToRegister) {
      this.refreshAfterAuthChange()
    }
    this.scheduleFlourishEmbeds()
  },
  updated() {
    this.scheduleFlourishEmbeds()
  },
  methods: {
    scheduleFlourishEmbeds() {
      if (typeof window === 'undefined' || this.flourishEmbedScheduled) return

      this.flourishEmbedScheduled = true

      this.$nextTick(() => {
        this.flourishEmbedScheduled = false
        this.loadFlourishEmbeds()
      })
    },
    async loadFlourishEmbeds() {
      if (!this.$el || this._isDestroyed) return

      const embeds = Array.from(this.$el.querySelectorAll('.flourish-embed[data-src]')).filter(
        (embed) => !embed.querySelector('iframe')
      )

      if (embeds.length === 0) return

      if (window.Flourish && typeof window.Flourish.loadEmbed === 'function') {
        embeds.forEach((embed) => this.loadFlourishEmbedElement(embed))
        return
      }

      try {
        await this.loadFlourishScript()
      } catch {
        // Fall back to direct iframes below.
      }

      if (!this.$el || this._isDestroyed) return

      Array.from(this.$el.querySelectorAll('.flourish-embed[data-src]')).forEach((embed) =>
        this.loadFlourishEmbedElement(embed)
      )
    },
    loadFlourishEmbedElement(embed) {
      if (!embed || embed.querySelector('iframe')) {
        return
      }

      try {
        if (window.Flourish && typeof window.Flourish.loadEmbed === 'function') {
          window.Flourish.loadEmbed(embed)
        }
      } catch {
        // Fall back to a direct iframe below.
      }

      if (!embed.querySelector('iframe')) {
        this.createFlourishFallbackIframe(embed)
      }
    },
    createFlourishFallbackIframe(embed) {
      const src = embed.getAttribute('data-src')

      if (!src) {
        return
      }

      const iframe = document.createElement('iframe')

      iframe.setAttribute('scrolling', 'no')
      iframe.setAttribute('frameborder', '0')
      iframe.setAttribute('title', 'Interactive or visual content')
      iframe.setAttribute(
        'sandbox',
        'allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'
      )
      iframe.setAttribute('data-telecompaper-flourish-fallback', 'true')

      iframe.style.width = embed.getAttribute('data-width') || '100%'
      iframe.style.height = this.getFlourishFallbackHeight(embed)
      iframe.src = this.getFlourishFallbackUrl(src)

      embed.appendChild(iframe)
      this.ensureFlourishResizeListener()
      this.addFlourishFallbackCredit(embed, src)
    },
    getFlourishFallbackUrl(src) {
      const questionMarkIndex = src.indexOf('?')
      const path = (questionMarkIndex === -1 ? src : src.slice(0, questionMarkIndex)).replace(/^\/+/, '')
      const queryString = questionMarkIndex === -1 ? '' : src.slice(questionMarkIndex + 1)
      const params = new URLSearchParams(queryString)

      params.set('utm_source', 'showcase')
      params.set('utm_campaign', path)
      params.set('auto', '1')

      const baseUrl = path.startsWith('template/')
        ? `${FLOURISH_APP_BASE_URL}/${path}/preview`
        : `${FLOURISH_EMBED_BASE_URL}/${path}/embed`

      return `${baseUrl}?${params.toString()}`
    },
    getFlourishFallbackHeight(embed) {
      const height = embed.getAttribute('data-height')

      if (height) {
        return /^\d+$/.test(height) ? `${height}px` : height
      }

      const width = embed.offsetWidth || embed.parentElement?.offsetWidth || 800
      return `${Math.round(Math.max(width * 0.62, 420))}px`
    },
    ensureFlourishResizeListener() {
      if (flourishResizeListenerAdded) {
        return
      }

      flourishResizeListenerAdded = true

      window.addEventListener('message', (event) => {
        if (!/^https:\/\/([a-z0-9-]+\.)*(flourish\.studio|uri\.sh)$/i.test(event.origin)) {
          return
        }

        let message = event.data

        if (typeof message === 'string') {
          try {
            message = JSON.parse(message)
          } catch {
            return
          }
        }

        if (!message || message.sender !== 'Flourish' || message.method !== 'resize' || !message.height) {
          return
        }

        let height = message.height

        if (typeof height === 'number') {
          height = `${height}px`
        } else if (typeof height === 'string' && /^\d+$/.test(height)) {
          height = `${height}px`
        }

        if (typeof height !== 'string') {
          return
        }

        document.querySelectorAll('iframe[data-telecompaper-flourish-fallback]').forEach((iframe) => {
          if (iframe.contentWindow === event.source) {
            iframe.style.height = height
          }
        })
      })
    },
    addFlourishFallbackCredit(embed, src) {
      if (embed.querySelector('.flourish-credit')) {
        return
      }

      const credit = document.createElement('div')
      const link = document.createElement('a')

      credit.className = 'flourish-credit'
      credit.style.cssText =
        'margin:4px 8px;text-align:right;font-family:system-ui,sans-serif;color:inherit;opacity:0.8;font-size:12px;font-weight:normal;font-style:normal;box-shadow:none;'

      link.href = `https://flourish.studio/?utm_source=showcase&utm_campaign=${encodeURIComponent(src)}`
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      link.textContent = 'Made with Flourish'
      link.style.cssText =
        'display:inline-block;text-decoration:none;font:inherit;color:inherit;border:none;box-shadow:none;'

      credit.appendChild(link)
      embed.appendChild(credit)
    },
    loadFlourishScript() {
      if (window.Flourish && typeof window.Flourish.loadEmbed === 'function') {
        return Promise.resolve()
      }

      if (flourishScriptLoadPromise) {
        return flourishScriptLoadPromise
      }

      const existingScript = document.getElementById(FLOURISH_LOADER_SCRIPT_ID)

      if (existingScript && existingScript.getAttribute('data-loaded') === 'true') {
        existingScript.remove()
      }

      flourishScriptLoadPromise = new Promise((resolve, reject) => {
        const script =
          existingScript && existingScript.getAttribute('data-loaded') !== 'true'
            ? existingScript
            : document.createElement('script')

        script.id = FLOURISH_LOADER_SCRIPT_ID
        script.src = FLOURISH_EMBED_SCRIPT_SRC
        script.async = true

        script.addEventListener(
          'load',
          () => {
            script.setAttribute('data-loaded', 'true')
            flourishScriptLoadPromise = null
            resolve()
          },
          { once: true }
        )

        script.addEventListener(
          'error',
          () => {
            script.remove()
            flourishScriptLoadPromise = null
            reject(new Error('Failed to load Flourish embed script'))
          },
          { once: true }
        )

        if (!script.parentNode) {
          window.Flourish = window.Flourish || {}
          window.FlourishLoaded = null
          document.head.appendChild(script)
        }
      })

      return flourishScriptLoadPromise
    },
    removeFlourishEmbeds() {
      if (!this.$el) {
        return
      }

      this.$el.querySelectorAll('.flourish-embed iframe, .flourish-credit').forEach((element) => {
        element.remove()
      })
    },
    async refreshAfterAuthChange() {
      if (this.isRefreshingAfterAuth) {
        return
      }

      this.isRefreshingAfterAuth = true
      const maxAttempts = 3

      try {
        for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
          const refreshed = await this.refresh(true)
          if (refreshed && !this.isUnexpectedPostLoginBlock()) {
            return
          }

          if (attempt < maxAttempts - 1) {
            this.showPlaceholder = true
            await this.wait(500 * (attempt + 1))
          }
        }

        if (typeof window !== 'undefined') {
          window.location.reload()
        }
      } finally {
        this.isRefreshingAfterAuth = false
      }
    },
    isUnexpectedPostLoginBlock() {
      return !!this.account && this.needToRegister
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async refresh(purge = false) {
      this.showPlaceholder = true
      this.article = null
      this.needToSubscribe = false
      this.needToRegister = false
      this.showSingleLogin = false

      this.$nuxt.$emit('topbanner', {
        isShow: true
      })

      const ARTICLE = gql`
        query GetArticle(
          $where: ArticleFilterInput
          $whereEdition: ArticleEditionFilterInput
          $whereCountry: ArticleCountryFilterInput
          $whereRegion: ArticleRegionFilterInput
          $whereCompany: ArticleCompanyFilterInput
          $whereAuthor: ArticleAuthorFilterInput
          $whereTag: ArticleTagFilterInput
          $whereUpdate: ArticleUpdateFilterInput
          $whereRelation: ArticleRelationFilterInput
          $whereProductPrice: ProductPriceFilterInput
        ) {
          article(where: $where) {
            id
            accessControl
            externalId
            date
            title
            slug
            abstract
            shortAbstract
            imageUrl
            redirectUrl
            content
            contentAfter
            filename
            isFree
            languageId
            language {
              locale
            }
            contentSource {
              id
              name
              website
            }
            edition {
              id
              name
            }
            contentType {
              id
              name
              colour
              contentTypeGroup {
                id
                name
              }
            }
            country {
              id
              name
            }
            region {
              id
              name
            }
          }
          articleEditions(where: $whereEdition) {
            nodes {
              edition {
                id
                name
                contentCollectionEditions(order: { contentCollection: { id: ASC } }) {
                  contentCollection {
                    id
                    slug
                    name
                  }
                }
              }
            }
          }
          articleCountries(where: $whereCountry, order: { country: { name: ASC } }) {
            nodes {
              country {
                id
                name
              }
            }
          }
          articleRegions(where: $whereRegion, order: { region: { name: ASC } }) {
            nodes {
              region {
                id
                name
              }
            }
          }
          articleCompanies(where: $whereCompany) {
            nodes {
              company {
                id
                name
              }
            }
          }
          articleAuthors(where: $whereAuthor) {
            nodes {
              user {
                id
                firstName
                lastName
              }
            }
          }
          articleTags(where: $whereTag) {
            nodes {
              tag {
                id
                name
                text
              }
            }
          }
          articleUpdates(where: $whereUpdate, order: [{ changedAt: DESC }]) {
            nodes {
              id
              changeText
              changedAt
            }
          }
          articleRelations(where: $whereRelation, order: [{ relatedArticle: { date: DESC } }]) {
            nodes {
              relatedArticle {
                id
                externalId
                date
                title
                slug
                abstract
                imageUrl
                redirectUrl
                contentType {
                  id
                  name
                  colour
                  contentTypeGroup {
                    id
                    name
                  }
                }
                edition {
                  id
                  name
                }
                country {
                  id
                  name
                }
                region {
                  id
                  name
                }
              }
            }
          }
          articleProductPrices(where: $whereProductPrice, order: [{ price: ASC }]) {
            nodes {
              id
              price
              license
              externalId
            }
          }
        }
      `

      let doingRedirect = false

      try {
        let where = {
          article: {
            externalId: {
              eq: this.externalId
            }
          }
        }

        let { data } = await this.$apollo.query({
          query: ARTICLE,
          variables: {
            where: {
              externalId: {
                eq: this.externalId
              }
            },
            whereEdition: where,
            whereCountry: where,
            whereRegion: where,
            whereCompany: where,
            whereAuthor: where,
            whereTag: where,
            whereUpdate: where,
            whereRelation: where,
            whereProductPrice: where
          },
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        // Check for access control from the API response
        if (data.article && data.article.accessControl) {
          const accessControl = data.article.accessControl

          switch (accessControl) {
            case 'subscribe':
              this.needToSubscribe = true
              break
            case 'register':
              this.needToRegister = true
              break
            case 'singlelogin':
              this.showSingleLogin = true
              break
          }

          if (accessControl) {
            this.setBreadcrumb({ isShow: false })
            this.$nuxt.$emit('topbanner', { isShow: false })
          }
        }

        if (data.article === null) {
          // It may have been deleted and redirected, check
          const redirectTo = await this.getExternalIdRedirectFromDeleted()
          if (redirectTo) {
            this.externalId = redirectTo
            where = {
              article: {
                externalId: {
                  eq: this.externalId
                }
              }
            }
            const result = await this.$apollo.query({
              query: ARTICLE,
              variables: {
                where: {
                  externalId: {
                    eq: this.externalId
                  }
                },
                whereEdition: where,
                whereCountry: where,
                whereRegion: where,
                whereCompany: where,
                whereAuthor: where,
                whereTag: where,
                whereUpdate: where,
                whereRelation: where,
                whereProductPrice: where
              },
              fetchPolicy: purge ? 'network-only' : 'cache-first'
            })
            data = result.data
          }
        }

        if (!data.article) {
          this.$router.push({
            path: `/?utm_source=-&utm_medium=-&utm_campaign=-&utm_content=ArticleNotAvailable`
          })
          return false
        }

        this.article = data.article
        this.article.articleEditions = data.articleEditions.nodes
        this.article.articleCountries = data.articleCountries.nodes
        this.article.articleRegions = data.articleRegions.nodes
        this.article.articleCompanies = data.articleCompanies.nodes
        this.article.articleAuthors = data.articleAuthors.nodes
        this.article.articleTags = data.articleTags.nodes
        this.article.articleUpdates = data.articleUpdates.nodes
        this.article.articleRelations = data.articleRelations.nodes
        this.article.productPrices = data.articleProductPrices.nodes
        if (typeof window !== 'undefined' && this.article.redirectUrl) {
          doingRedirect = true
          window.location.href = this.article.redirectUrl
          return true
        }

        if (
          this.article.slug !== this.titleSlug ||
          this.getContentTypeUrlName(this.article.contentType) !== this.contentTypeSlug ||
          this.queryId !== this.article.externalId
        ) {
          if (data.article.language.locale !== this.language) {
            this.setLanguage(data.article.language)
            return await this.refresh(true)
          }

          const fullPath = `/${this.getContentTypeUrlName(this.article.contentType)}/${this.article.slug}--${
            this.externalId
          }`

          // handle redirect for both SSR and client-side
          if (process.server && this.$nuxt.context?.redirect) {
            // server-side redirect (SSR)
            this.$nuxt.context.redirect(301, fullPath)
          } else if (typeof window !== 'undefined') {
            // client-side redirect
            this.$router
              .push({
                path: fullPath
              })
              .catch((err) => {
                // log navigation errors in development
                if (process.env.NODE_ENV === 'development' && err.name !== 'NavigationDuplicated') {
                  console.error('[ArticleContent] Router navigation error:', err)
                }
              })
          }
        }

        if (data.article.language.locale !== this.language) {
          this.setLanguage(data.article.language)
        }

        this.related =
          this.article && this.article.articleRelations
            ? this.article.articleRelations.map((x) => x.relatedArticle)?.slice(0, 20)
            : []

        this.productPrice =
          this.article && this.article.productPrices && this.article.productPrices.length > 0
            ? this.article.productPrices[0]
            : null

        if (this.article && !this.needToRegister && !this.needToSubscribe && !this.showSingleLogin) {
          this.setBreadcrumb({
            isShow: true,
            pageCategory: this.article.edition.name,
            categoryRedirectUrl: `/${this.article.edition.name}`,
            pageTitle: this.article.title
          })
        } else {
          this.setBreadcrumb({
            isShow: false
          })
        }

        if (this.article && this.startDownload) {
          this.download(this.article.id)
        }
        return true
      } catch (error) {
        this.handleError(error)
        return false
      } finally {
        this.showPlaceholder = doingRedirect
      }
    },
    setLanguage(language) {
      this.$i18n.setLocale(language.locale)
      this.$dayjs.locale(language.locale)
      this.$store.set('language/locale', language.locale)
      this.$nuxt.$emit('language-change', language)
    },
    async getExternalIdFromSlug() {
      try {
        const { externalId } = await this.$axios.$get(`/sync/translateslug/${this.titleSlug}`)
        return externalId
      } catch {
        return null
      }
    },
    async getExternalIdRedirectFromDeleted() {
      try {
        const { externalId } = await this.$axios.$get(`/sync/checkforredirect/${this.externalId}`)
        return externalId
      } catch {
        return null
      }
    },
    getAuthorsNames() {
      const names = []
      this.article.articleAuthors?.forEach((author) => {
        names.push(`${author.user.firstName} ${author.user.lastName}`)
      })
      return names.join(', ')
    },
    async download(id) {
      if (!this.account) {
        this.$nuxt.$emit('toggleRegisterModal', { isDownload: true })
        return
      }

      if (this.account.company == null || this.account.jobFunctionId == null) {
        this.isShowingCompleteAccount = true
        return
      }

      this.isDownloading = true
      try {
        const response = await this.$axios.$get(`${this.$config.apiRootUrl}/api/download/${id}`, {
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(response)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        // the filename you want
        a.download = this.article.filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.$buefy.toast.open({
          message: this.handleError(error),
          type: 'is-danger'
        })
      } finally {
        this.isDownloading = false
        this.startDownload = false
      }
    },
    addToCart() {
      this.$nuxt.$emit('onCartItemAdded', this.productPrice.externalId, null)
    },
    printArticle() {
      this.onShareClick('DOWNLOAD')
      window.print()
    },
    contentTypeNavigate(contentType) {
      this.setFilterOptions({ contentTypeId: contentType.id })
      this.$router.push({ path: '/all' })
    },
    companyNavigate(company) {
      const filters = JSON.parse(JSON.stringify(this.defaultFilters))
      filters.text = company.name

      this.$router.push({
        path: '/search',
        query: { f: encodeURIComponent(window.btoa(JSON.stringify(filters))) }
      })
    },
    regionNavigate(region) {
      this.setFilterOptions({ regionId: region.id })
      this.$router.push({ path: '/all' })
    },
    countryNavigate(country) {
      this.setFilterOptions({ countryId: country.id })
      this.$router.push({ path: '/all' })
    },
    onUserRegistered(result) {
      this.confirmationEmail = result.email
      this.password = result.password
      this.waitingForPin = true
    },
    onLoginClicked() {
      this.showLogin = true
      this.showForgotPassword = false
    },
    onRegisterClicked() {
      this.showLogin = false
    },
    onForgotPasswordClicked() {
      this.showLogin = false
      this.showForgotPassword = true
    },
    onUserConfirmed() {
      this.showLogin = false
      this.needToRegister = false
    },
    onLoginClick() {
      this.showSingleLogin = false
      this.needToRegister = true
      this.showLogin = true
    },
    onCompleteAccountSubmit() {
      this.download(this.article.id)
    },
    async onShareClick(location) {
      if (this.account == null) return

      try {
        await this.$apollo.mutate({
          mutation: CREATE_USER_SHARE,
          variables: { data: { articleId: this.article.id, location } }
        })
      } catch (error) {
        console.error('failed to record user share action', error)
      }
    }
  }
}
